import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
import { warning } from "@packages/share/components/notice";
import { ref, watch } from "vue";
// 定义Props
export default /*#__PURE__*/_defineComponent({
  __name: 'YAddValue',
  props: {
    modelValue: {
      type: Object,
      default: []
    },
    max: {
      type: String,
      default: 30
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    // 最多输入数量
    const maxLength = ref(props.max);
    // 属性值逻辑
    const addvalue = ref("");
    const allValueList = ref([]);
    watch(() => props.modelValue, v => {
      if (v && v.length) {
        v = v.map(item => {
          if (!item.attrName) {
            return {
              attrName: item,
              repeat: false
            };
          } else {
            return item;
          }
        });
        allValueList.value = v;
      }
    }, {
      immediate: true,
      deep: true
    });
    //添加值事件
    function show_add_value() {
      if (allValueList.value.length >= maxLength.value) {
        addvalue.value = "";
        return warning(`输入数量不能大于${maxLength.value}`);
      }
      if (addvalue.value == "") return;
      const list_num = ref(-1); //存储下标
      allValueList.value.forEach((item, index) => {
        item.repeat = false;
        if (item.attrName == addvalue.value) {
          list_num.value = index;
        }
      });
      if (list_num.value == -1) {
        allValueList.value.push({
          attrName: addvalue.value
          //   categoryId: 0,
          //   childList: [],
          //   id: 0,
          //   pid: 0,
          //   status: 0,
        });

        addvalue.value = "";
      } else {
        allValueList.value[list_num.value].repeat = true;
        addvalue.value = "";
        return warning("描述重复,请重新输入"); //返回重复警告
      }

      emit("update:modelValue", allValueList.value);
    }
    //删除单项属性描述
    function delete_list(x) {
      allValueList.value.splice(x, 1);
      emit("update:modelValue", allValueList.value);
    }
    //删除全部属性描述
    function delete_all() {
      allValueList.value = [];
      emit("update:modelValue", allValueList.value);
    }
    return (_ctx, _cache) => {
      const _component_Write = _resolveComponent("Write");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.css.from_dispaly)
      }, [_createVNode(_component_Write, {
        clearable: "",
        modelValue: addvalue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addvalue.value = $event),
        width: "260px",
        placeholder: "请输入，不能超过10个字符",
        maxlength: "10"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(_ctx.css.btn),
          onClick: _withModifiers(show_add_value, ["stop"])
        }, "添加", 10, _hoisted_1), _createTextVNode("   ")]),
        _: 1
      }, 8, ["modelValue"]), allValueList.value.length != 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.css.addvalue)
      }, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.css.addvalue_main)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allValueList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("p", {
          class: _normalizeClass({
            [_ctx.css.red]: item.repeat
          })
        }, _toDisplayString(item.attrName), 3), _createElementVNode("span", {
          onClick: $event => delete_list(index),
          class: "iconfont"
        }, "", 8, _hoisted_2)]);
      }), 128))], 2), _createElementVNode("div", {
        class: _normalizeClass(_ctx.css.addvalue_bottom)
      }, [_createElementVNode("span", {
        onClick: delete_all
      }, "全部删除"), _createElementVNode("span", null, _toDisplayString(allValueList.value.length) + "/" + _toDisplayString(maxLength.value), 1)], 2)], 2)) : _createCommentVNode("", true)], 2);
    };
  }
});